module.exports = __webpack_public_path__ + "img/CliAcneSet4.0a8c8e18.jpg";